// más de 3 letras/num iguales seguidas: aaaa, bbbb.. 1111, 2222..
export const repeatedCharacters = /(\w)\1{2,}/

// más de 2 números consecutivos
export const serialNumbers = /(012|123|234|345|456|567|678|789)+/

// más de 2 números consecutivos
export const serialCharacters =
  /(abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)+/

// contiene caracteres especiales
export const specialCharacters = /[!@#$%^&*(),.?":{}|<>]/

// contains numbers
export const containNumbers = /[0-9]/

// contains lowercase and uppercase
export const hasLowerAndUpper = /[a-z].*[A-Z]|[A-Z].*[a-z]/
